import { Button, Drawer, Image, Table } from "antd";
import layoutStorage from "../storages/layout-storage";
import { observer } from "mobx-react-lite";
import AddBrandDialog from './add-brand-dialog';
import brandsStorage from "../storages/brands";
import { IBrand } from "@drone-parts.garphild.pro/interfaces";

/* eslint-disable-next-line */
export interface SelectBrandDialogProps {
  opened: boolean;
  onToggle: () => void;
  onSelect: (brandId: IBrand['_id']) => void;
}

export function SelectBrandDialog(props: SelectBrandDialogProps) {
  const {
    opened,
    onToggle,
    onSelect,
  } = props;

  const {
    isAddBrandDialogOpened,
    toggleAddBrandDialog,
  } = layoutStorage;

  const {
    brands,
  } = brandsStorage;

  return (
    <Drawer
      title="Select brand"
      width={320}
      closable={true}
      onClose={onToggle}
      open={opened}
    >
      Select brand
      <Button type="primary" onClick={toggleAddBrandDialog}>
        Add brand
      </Button>
      <Table
        columns={[
          {
            title: "Logo",
            dataIndex: "logoUrl",
            key: "logoUrl",
            render: (logoUrl: string) => <Image preview={false} className="logo-in-table" src={`/${logoUrl}`} alt="logo" />,
            width: 100,
          },
          {
            title: "Name",
            dataIndex: "name",
            key: "name",
          }
        ]}
        dataSource={brands}
        onRow={(record) => {
          return {
            onDoubleClick: () => {
              onSelect(record._id);
            }
          };
        }}
      />
      <AddBrandDialog opened={isAddBrandDialogOpened} onToggle={toggleAddBrandDialog} />
    </Drawer>
  );
}

export default observer(SelectBrandDialog);
